import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";
import Tour from "reactour";

// {
/* <Reactour
  lastStepNextButton={
    <TrackedButton
      className="tour__btn--finish"
      variant="primary"
      onClick={this.onRequestClose}
      action="tourFinishClick"
      label={this.props.id}
    >
      Finish
    </TrackedButton>
  }
  steps={this.props.steps}
  isOpen={run}
  onRequestClose={this.onRequestClose}
  update={this.props.hashes[this.props.id] || ""}
/>; */
// }

type Props = {};

// transaction-manager-filter-fieldName
// transaction-manager-missing-transactions
// transaction-manager-pagination
// transaction-manager-transactions
// btn--report-bad-job
// btn--download-data
// transaction-manager-missing-transactions

const steps = [
  {
    selector: ".transaction-manager-accounts",
    content:
      "Select an account. DocuClipper displays all the transactions in that account. Each account contains one or more time periods. Click on the time period to only show transactions in that time period.",
  },
  {
    selector: ".transaction-manager-accounts-summary",
    content:
      "DocuClipper displays a summary of the account or period. When selecting a period, you can edit the start and end dates and start and end balances. You can also edit the account name and reassign a time period to a different account.",
  },

  {
    selector: ".transaction-manager-transactions",
    content:
      "Include or exclude each transaction by checking the box. Click on the field to correct the data (after closing the tutorial)",
  },
  {
    selector: ".transaction-manager-missing-transactions",
    content: `Click on "Add Transaction" to include any missing  transactions`,
  },

  {
    selector: ".btn--report-bad-job",
    content:
      "Did you run into any issues? Report the issues and get help from the support team",
  },

  {
    selector: ".btn--download-data",
    content:
      "Click here to download the data. DocuClipper supported formats include Excel, QuickBooks, Xero and other third party applications.",
  },

  // ...
];

export const TransactionManagerTour: React.FC<Props> = ({}) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button onClick={() => setOpen(true)} variant="secondary">
        <FontAwesomeIcon icon="play" />
        <span className="ml-1">Tutorial</span>
      </Button>
      <Tour steps={steps} isOpen={open} onRequestClose={() => setOpen(false)} />
    </>
  );
};
export default TransactionManagerTour;
